import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useKeyPress, useHelpModalState } from 'react-commons';
import { FlowService } from '../../../services';
import { useGlobalState } from '../../../state/persistence';
import { useStyles } from '../../Shared';

const usePostcode = (nextUrl: string) => {
  const { t } = useTranslation('postcode');
  const history = useHistory();
  const { dispatchQuestion } = useGlobalState();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onBlur' });
  const enterPressed = useKeyPress('Enter');
  const { toggleHelpModal } = useHelpModalState();
  const isBusiness = FlowService.isCheckBusiness();
  const pageTitle = isBusiness ? 'business_page_title' : 'page_title';
  const title = isBusiness ? 'business_title' : 'title';

  const onSubmit = useCallback(
    (data: { postcode?: string }) => {
      dispatchQuestion('postcode', data.postcode);
      history.push(nextUrl);
    },
    [nextUrl, history, dispatchQuestion],
  );

  useEffect(() => {
    if (enterPressed) handleSubmit(onSubmit)();
  }, [enterPressed, handleSubmit, onSubmit]);

  return {
    classes: useStyles(),
    t,
    pageTitle,
    title,
    handleSubmit: handleSubmit(onSubmit),
    register,
    errors,
    toggleHelpModal,
  };
};

export default usePostcode;
